var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leading-icon",
    clipPath: "url(#mapMarker)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16.9277C24 16.4263 23.6114 16.021 23.0857 15.8823C21.6343 15.509 20.5714 14.2717 20.5714 12.7997V7.46634H21.7143C22.3429 7.46634 22.8571 6.98634 22.8571 6.39967C22.8571 5.81301 22.3429 5.33301 21.7143 5.33301H10.2857C9.65714 5.33301 9.14286 5.81301 9.14286 6.39967C9.14286 6.98634 9.65714 7.46634 10.2857 7.46634H11.4286V12.7997C11.4286 14.2717 10.3657 15.509 8.91429 15.8823C8.38857 16.021 8 16.4263 8 16.9277V17.0663C8 17.653 8.51429 18.133 9.14286 18.133H14.8343L14.8571 25.5997C14.8571 26.1863 15.3714 26.6663 16 26.6663C16.6286 26.6663 17.1429 26.1863 17.1429 25.5997L17.12 18.133H22.8571C23.4857 18.133 24 17.653 24 17.0663V16.9277Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mapMarker"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/mapMarker.0dc6e25aea10b0a275c530f480ee623b.svg";
export { ForwardRef as ReactComponent };